export default {
  optionList: {
    NetBuyVol: 'Net Buy Vol.',
    NetSellVol: 'Net Sell Vol.',
    NetBuyVal: 'Net Buy Value',
    NetSellVal: 'Net Sell Value',
  },
};
